import api from "@/plugins/api/EntryPoint";

export default {
  getPrykarpattyaEnergoDataForPersonalAccount(callBackFn) {
    return api.get(`prykarpattya-personal-account/get-personal-account-data`, callBackFn);
  },
  setPrykarpattyaEnergoDataForPersonalAccount(data, callBackFn) {
    return api.post(`prykarpattya-personal-account/set-personal-account-data`, {ls: data.ls, last_pay: data.lastPay }, callBackFn);
  },
};
